import { render, staticRenderFns } from "./Fileinput.vue?vue&type=template&id=62fa4940&scoped=true&"
import script from "./Fileinput.vue?vue&type=script&lang=ts&"
export * from "./Fileinput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa4940",
  null
  
)

export default component.exports